import * as Protocol from './contribution-protocol';
import { contributionRegister } from './contribution-register';
export * from './contribution-protocol';
export * from './contribution-provider';
export * from './decorator';
export var Contribution;

(function (Contribution) {
  Contribution.Provider = Protocol.Provider;
  Contribution.register = contributionRegister;
})(Contribution || (Contribution = {}));